const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generic Excel/PDF export for tools. payload = { title, subtitle, meta:[{label,value}], sheets:[{name,headers,rows}] }
export async function exportGeneric(kind, payload) {
  const res = await fetch(`${API}/export/generic/${kind}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("export failed");
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safe = (payload.title || "My_Finanz_Planner").replace(/[^a-z0-9]+/gi, "_");
  a.download = `${safe}.${kind === "excel" ? "xlsx" : "pdf"}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
